import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      staleTime: 0,
      gcTime: 0,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
    },
  },
});

const defaultQuerySettings = {
  select: (data: unknown) => data,
};

const defaultQuerySettingsFetch = {};

export { defaultQuerySettings, defaultQuerySettingsFetch, queryClient };
